module.exports = __webpack_public_path__ + "images/498e9c8bf2d61cc5c5ba22224525611b0.svg";